import * as yup from 'yup';

export const getInvoiceVendorSchema = (vendors, row) =>
  yup.object().shape({
    name: yup.string().required('Vendor name is required'),
    bookingTypeId: yup.object().required('Booking type is required'),
    code: yup
      .string()
      .required('Vendor code is required')
      .test('unique-vendor-code', 'A vendor with this booking type and code already exists', (code, context) => {
        if (!code) return true;

        const { bookingTypeId } = context.parent;
        const match = vendors?.find(
          (v) => v.bookingTypeId === bookingTypeId?.id && v.code === code && v.id !== row?.id
        );
        return !match;
      }),
    subcode: yup.string().when('bookingTypeId', {
      is: (bookingTypeId) => Boolean(bookingTypeId?.name?.toLowerCase().includes('workday')),
      then: (s) => s.required('Vendor subcode is required for Workday booking types'),
      otherwise: (s) => s.nullable(),
    }),
    emailTo: yup.string().email('Invalid email').nullable(),
    address: yup.string().nullable(),
    city: yup.string().nullable(),
    state: yup.string().nullable(),
    zip: yup.string().nullable(),
    phone: yup.string().nullable(),
  });
